/**
 * The options every drag-to-reorder list in Backoffice is created with.
 *
 * SortableJS was being constructed bare — `Sortable.create(el)` — in all four sort pages. With a mouse
 * that is fine: dragging and scrolling are different gestures, one of them with the button held. With
 * a finger they are the SAME gesture, so on the Sunmi D3 a swipe meant to scroll a long category list
 * picked a row up and carried it instead, and the list could not be scrolled at all.
 *
 * A short hold is what tells them apart: press and stay, and the row is yours; swipe, and the list
 * scrolls. It applies to touch only — `delayOnTouchOnly` — so a mouse keeps its instant drag from
 * anywhere on the row, exactly as before.
 *
 * The whole row is draggable, not just the grip. The grip (.bo_drag-handle, touch only) is there to
 * say that a row CAN be dragged, since the hold is otherwise an invisible rule; it is a signpost, not
 * a gate, and behaves like any other part of the row. The page's own instruction line says the same
 * thing in words — see the sort pages.
 *
 * Read once per call rather than at import, so the answer is current if the page is opened after a
 * device changes hands.
 */
export default function sortableOptions() {
  const coarse = typeof window !== 'undefined'
      && window.matchMedia
      && window.matchMedia('(pointer: coarse)').matches;

  return {
    // Long enough that a scroll is never taken for a drag, short enough that a deliberate press does
    // not feel unanswered. Touch only: with a mouse, `delay` would put a pause on every reorder.
    delay: coarse ? 150 : 0,
    delayOnTouchOnly: true,

    // A finger is never perfectly still during that hold; without a little tolerance the drag is
    // cancelled before it starts.
    touchStartThreshold: 5,

    // The row slides to its new place rather than jumping, which is what tells you the drop landed —
    // on a touch screen your own hand is covering the row.
    animation: 150,

    // A list longer than the screen has to scroll while a row is held at its edge, or the row can
    // only be moved as far as the fold.
    scroll: true,
    scrollSensitivity: 60,
    scrollSpeed: 12,
  };
}
